module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=ZA - South Africa.e31b91c2.svg";